export default "__VITE_ASSET__DHqbyQSs__"